import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

import TableCell from './TableCell';

const TableCellExpandable = ({ children, className, isOpen, ...props }) => {
  const { classes, cx } = useStyles(styles, { toggle: isOpen });

  return (
    <TableCell className={cx(classes.tableCell, className)} {...props}>
      {children}
    </TableCell>
  );
};

const styles = ({ shape: { borderRadius } }, { toggle }) => ({
  tableCell: {
    '&.MuiTableCell-body': {
      ...(toggle && {
        borderBottom: 'none',
        '&:first-child': {
          borderRadius: `${borderRadius}px 0 0 0`,
        },
        '&:last-child': {
          borderRadius: `0 ${borderRadius}px 0 0`,
        },
      }),
    },
  },
});

TableCellExpandable.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isOpen: PropTypes.bool,
};

export default TableCellExpandable;
